// extracted by mini-css-extract-plugin
export default {"label":"HostBusyLabel_label__Uf4lx"};